import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import withAuth from '../../../components/hocs/withAuth';
import Avatar from '../../../components/cards/CardComponents/Avatar';

import styles from './profileCard.scss';

const formatMatch = (match) => {
    const { won, opponent1, opponent2, score } = match;
    const def = won ? 'Def.' : 'Def. by';
    return `${def} ${opponent1} ${opponent2 ? `/${opponent2}` : ''}, ${score}`;
};

const ProfileCard = (props) => {
    const { firstName, lastName, gender, location, lastResult, onProfileSelect, disabled, id } = props;
    const sportType = lastResult?.sportType ?? '';

    return (
        <div className={styles.profileCard} data-testid={`nuo-v2.matching-profiles.profile-card-${id}`}>
            <div className={styles.header}>
                <div className={styles.avatar}>
                    <Avatar profile={{ firstName, lastName }} />
                </div>
                <div className={styles.nameWrapper}>
                    <Link to={`/profiles/${id}`} target="_blank" data-testid={`nuo-v2.matching-profiles.profile-card-${id}.profile-link`}>
                        <div className={styles.name}>
                            <div data-testid={`nuo-v2.matching-profiles.profile-card-${id}.name`}>{firstName} {lastName}</div>
                        </div>
                    </Link>
                    <div className={styles.description} data-testid={`nuo-v2.matching-profiles.profile-card-${id}.description`}>
                        {gender}&nbsp;&bull;&nbsp;
                        {location && location.display}
                    </div>
                </div>
            </div>
            <div className={styles.content}>
                <div className={styles.lastMatch}>
                    <div className={styles.lastMatchTitle} data-testid={`nuo-v2.matching-profiles.profile-card-${id}.last-match-title`}>Recent {sportType} match played {lastResult && ` - ${moment(lastResult.date).format('MM/DD/YYYY')}`}</div>
                    <div data-testid={`nuo-v2.matching-profiles.profile-card-${id}.last-match-result`}>
                        {lastResult ? formatMatch(lastResult) : '-'}
                    </div>
                </div>
                <div className={styles.buttons}>
                    <button
                        type="button"
                        className={`btn btn-default btn-block text-uppercase mt16`}
                        onClick={(e) => onProfileSelect(props, e)}
                        disabled={disabled}
                        data-testid={`nuo-v2.matching-profiles.profile-card-${id}.select-btn`}
                    >
                        Yes, This is me
                    </button>
                </div>
            </div>
        </div>
    );
};

ProfileCard.propTypes = {
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    gender: PropTypes.string,
    location: PropTypes.object,
    lastResult: PropTypes.object,
    onProfileSelect: PropTypes.func,
    disabled: PropTypes.string,
    id: PropTypes.string,
};

export default withAuth(ProfileCard);
